export default __webpack_public_path__ + "static/media/Motion.6bc6bf47.mp4";